import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import Typed from 'typed.js';
import { motion } from 'framer-motion';

const Hero = () => {
  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ['Web-Developer', 'Designer', 'App Developer', 'Freelancer'],
      typeSpeed: 50,
      backSpeed: 50,
      loop: true
    });

    return () => typed.destroy();
  }, []);

  return (
    <HeroContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <CodeLine>const Developer = {`{`}</CodeLine>
      <Content>
        <Greeting>Hi, I'm <span>Tahia</span></Greeting>
        <TypedContainer>I'm a <span ref={el}></span></TypedContainer>
        <Description>
          I build things for the web
        </Description>
      </Content>
      <CodeLine>{`}`};</CodeLine>
    </HeroContainer>
  );
};

const HeroContainer = styled(motion.div)`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 10%;
`;

const CodeLine = styled.div`
  color: #64ffda;
  font-size: 1.2rem;
`;

const Content = styled.div`
  margin-left: 2rem;
`;

const Greeting = styled.h1`
  font-size: 3rem;
  color: #ccd6f6;
  span {
    color: #64ffda;
  }
`;

const TypedContainer = styled.h2`
  font-size: 2rem;
  color: #8892b0;
  span {
    color: #64ffda;
  }
`;

const Description = styled.p`
  font-size: 1.5rem;
  margin-top: 1rem;
`;

export default Hero;